import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { BASE_URL } from '../constants/constants';
import { getValueFromStorage } from '../helpers/helpers';

export const statsApi = createApi({
  reducerPath: 'stats',
  baseQuery: fetchBaseQuery({
    baseUrl: BASE_URL,
    prepareHeaders: headers => {
      headers.set('Content-type', 'application/json');
      headers.set('authorization', `Bearer ${getValueFromStorage('token')}`);
      return headers;
    },
  }),
  endpoints: builder => ({
    getLogs: builder.query({
      query: ({ currentPage = 1, resultPerPage = 10, type }) => ({
        url: `/api/stats/getLogs`,
        method: 'GET',
        params: {
          current_page: currentPage,
          result_per_page: resultPerPage,
          type: type,
        },
      }),
    }),
    getIncomeStats: builder.query({
      query: () => ({
        url: `/api/stats/income`,
        method: 'GET',
      }),
    }),
  }),
});

export const { useGetLogsQuery, useLazyGetLogsQuery, useGetIncomeStatsQuery } =
  statsApi;
